// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1682":"a6492bfa","7381":"9a3f3125","8867":"e69dcf09"}[chunkId] + ".chunk.css";
};